export const paths = [
	{
		name: 'About Me',
		to: '/',
	},
	{ to: '/work', name: 'Work' },
	{ to: '/contact', name: 'Contact' },
	{ to: '/education', name: 'Education' },
]
